import React from "react";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton.jsx";
import { renderField } from "./_fieldRenderer";

import "./forms.css";

const validate = (values) => {
  const errors = {};
  if (!values.password) {
    errors.password = "Obrigatório";
  } else if (values.password.length < 6) {
    errors.password = "Min. 6 caracteres";
  }
  return errors;
};

class PasswordForm extends React.Component {
  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="password"
                type="password"
                component={renderField}
                placeholder="Nova senha"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Alterar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };
}

PasswordForm = reduxForm({ form: "PasswordForm", validate })(PasswordForm);
export default PasswordForm;



// WEBPACK FOOTER //
// ./src/forms/PasswordForm.jsx